// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__mUcqf","overlay":"menu_overlay__tzwVo"};